import { Component, computed, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { TrierParPipe } from '@shared/pipes/trier-par.pipe';
import { BrnSelectImports } from '@spartan-ng/brain/select';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmSelectImports } from '@spartan-ng/helm/select';

import { Cartographie } from '../../cartographie/models/cartographie.model';
import { CartographieStore } from '../../cartographie/store/cartographie.store';
import { ParcoursStore } from '../../référentiel-métier-parcours/store/parcours.store';
import { CardEtapeCartoComponent } from './card-étape-carto/card-etape-carto.component';

@Component({
  selector: 'app-administration',
  imports: [
    HlmButtonImports,
    CardEtapeCartoComponent,
    HlmCardImports,
    HlmSelectImports,
    TrierParPipe,
    BrnSelectImports,
  ],
  templateUrl: './administration.component.html',
})
export class AdministrationComponent {
  readonly #cartographieStore = inject(CartographieStore);
  readonly #parcoursStore = inject(ParcoursStore);
  readonly #router = inject(Router);

  protected readonly cartographie = signal<Cartographie | null>(null);
  protected readonly cartographies = computed(() => this.#cartographieStore.actives());

  readonly isLoading = signal(false);

  constructor() {
    this.#cartographieStore.charger();
  }

  setCartographieCourante(cartographie: Cartographie) {
    this.cartographie.set(cartographie);
  }

  navigateTo(path: string) {
    const cartographie = this.cartographie();
    if (path === 'gestion') {
      this.#router.navigate(['admin', 'cartographies', path]);
    } else if (
      path === 'techniques-animation' ||
      path === 'certifications' ||
      path === 'trigrammes-type-certification' ||
      path === 'messages-information'
    ) {
      this.#router.navigate(['admin', path]);
    } else if (cartographie) {
      this.#router.navigate(['admin', 'cartographies', cartographie.slug, path]);
    }
  }

  exportCartographie() {
    const cartographie = this.cartographie();
    if (!cartographie) return;

    this.isLoading.set(true);
    this.#parcoursStore.exportCartographie({
      idCartographie: cartographie.id,
      next: (blob: Blob) => this.downloadCSV(blob),
      error: () => this.isLoading.set(false),
    });
  }

  downloadCSV(blob: Blob) {
    const cartographie = this.cartographie();
    if (!cartographie) return;

    const filename = `export-${cartographie.nom.replace(' ', '-').toLocaleLowerCase()}.csv`;

    const downloadLink = document.createElement('a');
    const url = URL.createObjectURL(new Blob([blob], { type: 'text/csv;charset=utf-8' }));
    downloadLink.href = url;
    downloadLink.download = filename;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    downloadLink.remove();
    URL.revokeObjectURL(url);
    this.isLoading.set(false);
  }
}
